export default __webpack_public_path__ + "static/media/showroom40.c12ead5f.webp";